module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"action":"Leia Mais"},"en":{"action":"Read More"},"es":{"action":"Ler más"}}')
  delete Component.options._Ctor
}
